/* src/components/pdf-page-project-tis/pdf-page-project-tis.component.scss */
app-pdf-page-project-tis {
  display: block;
}
.table-row--with-attachments {
  border-bottom: 0;
}
.table-row--attachments {
  border-top: 0;
}
/*# sourceMappingURL=pdf-page-project-tis.component-67FUAN7W.css.map */
